import axios from 'axios'
import type { BoxTruckStateLoadCount } from '@numeo/types-core'
import { getApiBaseUrlWithoutV1 } from '@/setup/SetupAxios'
import type { BoxTruckMapDriver, BoxTruckMapOverview } from './boxTruckLoadsApi'

const NON_V1_BASE = getApiBaseUrlWithoutV1()
const MAP_REQUEST_TIMEOUT_MS = 15_000

/** Fast initial map payload: every fresh driver visible to this operator, without load aggregation. */
export async function fetchBoxTruckMapDrivers(): Promise<BoxTruckMapDriver[]> {
    try {
        const response = await axios.get<{ success: boolean; data: { drivers: BoxTruckMapDriver[] } }>('/box-truck-loads/map/drivers/v1', {
            baseURL: NON_V1_BASE,
            timeout: MAP_REQUEST_TIMEOUT_MS,
        })
        return response.data.data.drivers
    } catch (error) {
        if (!axios.isAxiosError(error) || error.response?.status !== 404) throw error
        const legacy = await axios.get<{ success: boolean; data: Pick<BoxTruckMapOverview, 'drivers'> }>('/box-truck-loads/map/overview/v1', {
            baseURL: NON_V1_BASE,
            timeout: MAP_REQUEST_TIMEOUT_MS,
        })
        return legacy.data.data.drivers
    }
}

/** Active Sylectus load counts for only the selected or visible detailed-map states. */
export async function fetchBoxTruckMapStateLoads(states: string[]): Promise<BoxTruckStateLoadCount[]> {
    const response = await axios.get<{ success: boolean; data: { loadsByState: BoxTruckStateLoadCount[] } }>('/box-truck-loads/map/state-loads/v1', {
        baseURL: NON_V1_BASE,
        params: { states: states.join(',') },
        timeout: MAP_REQUEST_TIMEOUT_MS,
    })
    return response.data.data.loadsByState
}
